module.exports = __webpack_public_path__ + "media/images/icons/vehicle-storage-large-10x30-653f930b273f1dacccd003ab733b972f.png";